import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnnouncementDetail, Announcements } from '../../models/announcements';
import { Session } from '../../services/session.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-announcements',
    template: `
    @if (announcements == null) {
      <mat-spinner
        color="accent"
        diameter="40"
        mode="indeterminate"
      ></mat-spinner>
    }
    
    @if (announcements != null && announcements.length > 0) {
      <div class="overlay">
        @for (item of announcements; track item) {
          <div>
            @if (item?.announcementsName != 'Custom') {
              <span
                class="AnnouncementHeaderH2"
                >{{ item?.announcementsName | translation : translationRequest}}</span
                >
              }
              @for (item1 of item.announcementDetails; track item1) {
                <span>
                  <p
                    [innerHTML]="
                      announcementBodyTranslationKey(item1)
                        | translationClientCustomization
                          : item1?.announcementsText
                          : translationRequest
                          : true
                    "></p>
                  <br />
                  <hr style="color:#D2D8E1 !important" aria-hidden="true" />
                  <hr style="color:#D2D8E1 !important" />
                </span>
              }
              <br />
            </div>
          }
          <mat-dialog-actions align="end" class="mySedwick-popupFooter">
            <mat-checkbox
              aria-label="Do not show these announcements on future logins | translation : translationRequest"
              (change)="doNotShowAnnouncement($event)"
              class="pad-right-5"
              >{{ 'Do not show again' | translation : translationRequest }}</mat-checkbox
              >
              <app-button
                mat-button
                aria-label="Close this popup"
                [mat-dialog-close]="true"
                aria-label="OK"
                emphasis="High"
                class="btn-info"
                (click)="acceptedAnnouncements()"
                label="OK"
              ></app-button>
            </mat-dialog-actions>
          </div>
        }
    `,
    styles: [
        `
      .close.mat-mdc-button {
        float: right;
        position: relative;
      }
      .pad-right-5 {
        padding-right: 2em;
      }
      .btn-info {
        font-size: 15px;
        color: #ffffff;
        line-height: 30px;
        border-radius: 40px;
        background: #007dbc;
      }
      .btn-info:hover {
        background: #035e81;
      }
      .AnnouncementHeaderH2 {
        color: #171c20;
        font-size: 17px;
        font-weight: bold;
      }
    `,
    ],
    standalone: false
})
export class AnnouncementsComponent {
  announcements: Announcements[];
  doNotShowIds: any = [];

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
    multipleKeyAllowed: 'AnnouncementsText',
  });

  title: string = 'Announcements';
  index: number = 0;
  announcementChecked: boolean = false;
  showAnnouncements: boolean = false;
  constructor(
    private http: HttpClient,
    public session: Session,
    private translationService: TranslationService,
    public dialogRef: MatDialogRef<AnnouncementsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.announcements = data?.announcements ?? [];
  }
  
  announcementBodyTranslationKey(detail: AnnouncementDetail): string {
    if (detail?.announcementsId == null) {
      return 'AnnouncementsText';
    }
    return `AnnouncementsText|${detail.announcementsId}`;
  }

  close(result: string = null) {
    sessionStorage.setItem('closed-announcements', 'true');
    this.dialogRef.close(result);
  }
  async ngOnInit() {
    if (this.announcements == null || this.announcements.length == 0) {
      this.closeModalPopUp();
      return;
    }

    const language = sessionStorage.getItem('languagepreference');
    this.translationRequest.language = language;

    if (this.translationService.isLanguagePreferenceSet()) {
      await this.translationService.mergeTranslationsFromRequest(
        new TranslationRequest({
          language,
          key: null,
          contNum: Number(this.session.user.contNum),
          tableName: null,
          primaryKey: null,
          primaryValue: null,
          lob: null,
          group: 'Shared',
          subGroup: 'Shared',
          multipleKeyAllowed: 'AnnouncementsText',
          saveToCache: false,
        })
      );
    }

    this.dialogRef.afterClosed().subscribe(() => {
      sessionStorage.setItem('closed-announcements', 'true');
    });
  }
  async acceptedAnnouncements() {
    if (this.announcementChecked && !this.session.user.isEmulating) {
      const announcementIds: any = [];
      this.announcements
        .flatMap((x) => x.announcementDetails)
        .forEach((y) => {
          announcementIds.push(y.announcementsId);
        });
      this.http
        .post<void>(
          `/api/user/Announcements/setAnnouncementsDismiss`,
          announcementIds
        )
        .subscribe(() => {
          this.close();
        });
    } else {
      this.close();
    }
    sessionStorage.setItem('closed-announcements', 'true');
  }
  closeModalPopUp() {
    this.dialogRef.close();
  }
  async doNotShowAnnouncement(event: any) {
    this.announcementChecked = event.checked;
  }
}
